const namespaced = true

import api from '../../../api/sap/warehouses_sap.js';

const state = {
    warehouses_sap: [],
}
const mutations = {
    MUTATION_SET_WAREHOUSES_SAP(state, data){
         state.warehouses_sap = data;
    }
}
const actions = {
    getWarehouses(context) {
        api.getWarehouses().then(function (res) {
            context.commit('MUTATION_SET_WAREHOUSES_SAP', res.data);
        }).catch((e) => {
            context.dispatch('notifications/add',{'color': 'error', 'visibility' : true, 'timeout': 5000, 'text': e.messages}, {root: true });
        })
    },
}

const getters = {}

export default {
     namespaced,
     state,
     mutations,
     actions,
     getters,
}